import { render } from "./ParentSection.vue?vue&type=template&id=0b7d7744&scoped=true"
import script from "./ParentSection.vue?vue&type=script&lang=js"
export * from "./ParentSection.vue?vue&type=script&lang=js"

import "./ParentSection.vue?vue&type=style&index=0&id=0b7d7744&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7d7744"]])

export default __exports__